/*
  ensure amount is number or return defaultAmount
  always return number
*/

export const normalizeAmount = (
  amount: number | string = 0,
  defaultAmount = 0
) => {
  const asInt = Number(amount)
  if (!!asInt && !isNaN(asInt)) {
    return asInt
  }

  return defaultAmount
}
